import {Language} from '@/ts/types/component/localization.type';
import {LANGUAGE} from '@/ts/utils/consts';

/**
 * The deployment's own language (`LANGUAGE` in its runtime configuration), for a reader whose
 * browser asks for none Balm speaks. English if the configuration names one it does not.
 */
function deploymentLanguage(): Language {
  return Object.values(Language).includes(LANGUAGE as Language) ? LANGUAGE as Language : Language.English;
}

/**
 * Central configuration for supported languages.
 * Single source of truth - defined here to avoid circular dependencies.
 */
export const SUPPORTED_LANGUAGES: Language[] = [
  Language.English,
  Language.German,
];

/**
 * Detects browser language preferences
 * @returns Language if browser language is supported, the deployment's own language otherwise. It
 * used to be English whatever the deployment said, so `LANGUAGE` never reached a reader whose
 * browser asked for French (IPD-3543).
 */
export function detectBrowserLanguage(): Language {
  if (typeof navigator === 'undefined' || !navigator.languages) {
    return deploymentLanguage();
  }

  const browserLangs = navigator.languages.map(lang => new Intl.Locale(lang).language);
  return browserLangs.find(bl => SUPPORTED_LANGUAGES.includes(bl as Language)) as Language ?? deploymentLanguage();
}
